import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

export type Vars = {
  [key: string]:
    | string
    | number
    | undefined
    | ReactNode
    | ((text: ReactNode) => ReactNode);
};

export type Translate = (id?: string, vars?: Vars) => ReactNode;

export type UseTranslate = () => Translate;

const useTranslate: UseTranslate = () => {
  const { formatMessage } = useIntl();

  return (id?: string, vars = {}): ReactNode | string =>
    id
      ? formatMessage(
          { id },
          { br: () => <br />, b: text => <b>{text}</b>, ...vars }
        )
      : '';
};

export default useTranslate;
